// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2sslt","col":"styles_col__2l_uO"};